import { useLocation } from "react-router-dom";

export const useTracking = () => {
  const { search } = useLocation();

  const withTracking = (path) => {
    if (!search) return path;
    return `${path}${search}`;
  };

  const getTrackingParams = () => {
    const params = new URLSearchParams(search);
    const keys = [
      "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
      "fbclid", "gclid", "fbc", "fbp",
    ];
    const out = {};
    keys.forEach((k) => {
      const v = params.get(k);
      if (v) out[k] = v;
    });
    return out;
  };

  return { withTracking, getTrackingParams };
};
